// Interruttori "nascondi prodotti / nascondi ricette" applicati PRIMA di renderizzare la rotta,
// sia in SSR sia in navigazione client: se la sezione è spenta, si va in home.
// Prima il controllo era solo nel componente (dopo il primo render), e a volte la pagina restava visibile.
import { redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

export type VisibilityKey = "hide_products" | "hide_recipes";

export async function assertSectionVisible(key: VisibilityKey) {
  const { data } = await supabase.from("site_settings").select("value").eq("key", key).maybeSingle();
  const v = (data as { value?: unknown } | null)?.value;
  if (v === true || v === "true") throw redirect({ to: "/", replace: true });
}
